import { proxy } from 'valtio'

export const gorich55688_patternStore = proxy({
  pattern: '計算中',
})
